<template>
  <div>
    <!-- 搜索筛选 -->
    <el-form :model="form" class="user-search" label-width="100px" size="small">
      <el-row>
        <el-col :span="7" >
            <el-form-item label="产品编号">
              <el-input size="small" v-model="form.productCode" placeholder="请输入产品编号" clearable></el-input>
            </el-form-item>
        </el-col>

        <el-col :span="7" >
          <el-form-item label="产品名称">
            <el-input size="small" v-model="form.productName" placeholder="请输入产品名称" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7" >
          <el-form-item label="产品规格">
            <el-input size="small" v-model="form.specs" placeholder="请输入产品规格" clearable></el-input>
          </el-form-item>
        </el-col>


        <el-col :span="3" class="text-align-right">
          <el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button>
        </el-col>
        <div v-if="!isFold">
          <el-col :span="7">
          <el-form-item label="来源单据编号">
            <el-input size="small" v-model="form.receiptCode" placeholder="请输入来源单据编号" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="来源单据类型">
            <el-select
                  v-model="form.receiptType"
                  clearable

                  filterable
                  placeholder="来源单据类型"
                  style="width:100%;"
                  @change="receiptTypeChange"
                >
                  <el-option
                    v-for="item in receiptTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="库存类型">
            <el-select
                  v-model="form.stockType"
                  clearable
                  multiple
                  filterable
                  placeholder="请选择库存类型"
                  style="width:100%;"
                >
                  <el-option
                    v-for="item in instockTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="库存收发时间">
            <el-select v-model="form.instockTime" placeholder="请选择" style="width: 120px;" @change="instockTimeChange('changedTime')" clearable>
              <el-option
                v-for="item in conditionOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-date-picker
             v-if="form.instockTime == 'between'"
             key="0"
             class="normal-half-width"
              v-model="form.changedTime"
              type="daterange"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00','23:59:59']"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
            <el-date-picker
            v-if="form.instockTime !== 'between' && form.instockTime !== 'auto'"
            class="normal-half-width"
            v-model="form.changedTime"
            type="datetime"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
          <el-select v-model="form.changedTime" placeholder="请选择"
            v-if="form.instockTime == 'auto'" class="normal-half-width"
            :class="{'w120':form.dynamicCreateValue == '7'}"
            @change="dynamicCreateValueChange">
            <el-option
              v-for="item in dynamicDate"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="form.changedTime" placeholder="请选择"
            v-if="form.instockTime == 'auto' && form.dynamicCreateValue == '7'"
            style="margin-top: 8px;width: 120px;">
            <el-option
              v-for="item in dateOneOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-tooltip content="只支持1-365的正整数">
            <el-input-number v-if="form.instockTime == 'auto' && form.dynamicCreateValue == '7'" @blur="dateInputCreateBlur" v-model="form.changedTime" step-strictly controls-position="right" :min="1" :max="365" style="margin-left: 8px;margin-top: 8px;width: 120px;"></el-input-number>
          </el-tooltip>
          <el-select v-model="form.changedTime" placeholder="请选择" v-if="form.instockTime == 'auto' && form.dynamicCreateValue == '7'" style="margin-left: 8px;margin-top: 8px;width: calc(100% - 264px);">
            <el-option
              v-for="item in dateTwoOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7" >
            <el-form-item label="备注">
              <el-input size="small" v-model="form.remark" placeholder="请输入备注" clearable></el-input>
            </el-form-item>
        </el-col>

        <el-col :span="7" >
          <el-form-item label="单据数量">
            <el-input-number :step="1" :min="0" size="small" v-model="form.receiptNum" placeholder="请输入单据数量" clearable></el-input-number>
          </el-form-item>
        </el-col>


        </div>
      </el-row>
      <el-divider><i :class="!isFold?'el-icon-caret-top':'el-icon-caret-bottom'" @click="fold"></i></el-divider>
    </el-form>
  </div>
</template>
<script>
export default {
  props:['form'],
  data() {
    return {
      isFold:true,
      conditionOptions: [
        {
          value: "between",
          label: "选择范围"
        },
        {
          value: "lt",
          label: "小于"
        },
        {
          value: "lte",
          label: "小于等于"
        },
        {
          value: "eq",
          label: "等于"
        },
        {
          value: "gt",
          label: "大于"
        },
        {
          value: "gte",
          label: "大于等于"
        }
      ],
      dynamicDate: [{
        value: '0',
        label: '今天',
      }, {
        value: '1',
        label: '昨天'
      }, {
        value: '2',
        label: '本周'
      }, {
        value: '3',
        label: '上周'
      }, {
        value: '4',
        label: '本月'
      }, {
        value: '5',
        label: '上月'
      }, {
        value: '6',
        label: '近三月'
      }, {
        value: '7',
        label: '自定义'
      }],
      dateOneOptions:[{
        value: '过去',
        label: '过去'
      }, {
        value: '未来',
        label: '未来'
      }],
      dateTwoOptions:[{
        value: '日',
        label: '日'
      }, {
        value: '周',
        label: '周'
      }, {
        value: '月',
        label: '月'
      }, {
        value: '季度',
        label: '季度'
      }, {
        value: '年',
        label: '年'
      }],
      instockTypeList: [{
        label:'普通出库',
        value:'普通出库'
      },{
        label:'退料入库',
        value:'退料入库'
      },{
        label:'销售出库',
        value:'销售出库'
      },{
        label:'生产出库',
        value:'生产出库'
      },{
        label:'调拨出库',
        value:'调拨出库'
      },{
        label:'采购退货出库',
        value:'采购退货出库'
      },{
        label:'其它出库',
        value:'其它出库'
      }],
      receiptTypeList:[{
        label:'出库单',
        value:'出库单'
      },{
        label:'入库单',
        value:'入库单'
      }],
    }
  },
  mounted(){
    this.form.receiptType = "";
    this.instockTypeList = [];
  },
  methods: {
    receiptTypeChange(val){
      this.form.stockType = [];
      if(val == '入库单'){
        this.instockTypeList = [{
            label:'普通入库',
            value:'普通入库'
          },{
            label:'退料入库',
            value:'退料入库'
          },{
            label:'采购入库',
            value:'采购入库'
          },{
            label:'成品入库',
            value:'成品入库'
          },{
            label:'调拨入库',
            value:'调拨入库'
          },{
            label:'销售退货入库',
            value:'销售退货入库'
          },{
            label:'其他入库',
            value:'其他入库'
        }];
      }else{
        this.instockTypeList = [{
          label:'普通出库',
          value:'普通出库'
        },{
          label:'销售出库',
          value:'销售出库'
        },{
          label:'生产出库',
          value:'生产出库'
        },{
          label:'调拨出库',
          value:'调拨出库'
        },{
          label:'采购退货出库',
          value:'采购退货出库'
        },{
          label:'其它出库',
          value:'其它出库'
        }]
      }
    },
    // 自定义时 默认给1
    dynamicCreateValueChange:function(){
      if(this.form.dynamicCreateValue == '7'){
        this.$set(this.form,'dateCreateInput','1')
      }else{
        delete this.form.dateCreateInput
      }
    },
    dynamicUpdateValueChange:function(){
      if(this.form.dynamicUpdateValue == '7'){
        this.$set(this.form,'dateUpdateInput','1')
      }else{
        delete this.form.dateUpdateInput
      }
    },
    dateInputUpdateBlur:function(){
      if(this.form.dateUpdateInput == undefined){
        this.$set(this.form,'dateUpdateInput','1')
      }
    },
    dateInputCreateBlur:function(){
      if(this.form.dateCreateInput == undefined){
        this.$set(this.form,'dateCreateInput','1')
      }
    },
    search() {
      // this.getdata(this.form)
      this.$emit('search',this.form);
    },
    fold(){
      this.isFold = !this.isFold;
    },
    instockTimeChange:function(val){
      this.$set(this.form,'dynamicCreateValue','')
      this.$set(this.form,val,'')
    },
  },
}
</script>
<style scoped>
.user-search {
  margin-top: 20px;
}
.normal-half-width{
  width: calc(100% - 132px);
  margin-left: 8px;
}
.el-divider__text{
  padding: 0px 0px;
  font-size: 20px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/stockManagement/stockRDDetail/ListTop.vue